import { createStore, combineReducers } from "redux";
import user from "./User";
import environment from "./Environment";

const store = createStore(combineReducers({
    user,
    environment,
}), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

export default store;